class _Holder {
    get discreteInfoString() {
        return this.firstNameInitial + ' ' + this.lastNameInitial + ' ' + this.birthDateStringShort;
    }
}

export default _Holder;
